<template>
  <div class="card">
    <div class="card-content">

      <slot></slot>

      <ul class="collection" v-if="Object.keys(myinsurance) !== 0" :key="updater">

        <li
            v-for="file in files"
            :key="file.Key"
            class="collection-item avatar"
        >

          <i v-if="file.doc_type === 'certificate'" class="material-icons circle blue">verified_user</i>
          <i v-else-if="file.doc_type === 'policy'" class="material-icons circle red">security</i>
          <i v-else-if="file.doc_type === 'receipt'" class="material-icons circle green">attach_money</i>


          <span class="title">{{ file.fileName }} - {{ formatBytes(file.Size) }}</span>
          <p><span v-html="doc_type_name(file.doc_type)"/><br>
            Caricato il {{ file.LastModified }}
          </p>
          <div class="secondary-content">
            <button type="button" class="btn btn-small" @click="deleteFile(file.Key)"><i class="material-icons">delete</i></button>
            <button type="button" class="btn btn-small" @click="downloadFile(file.Key)"><i class="material-icons">file_download</i></button>
          </div>

        </li>

      </ul>

    </div>
    <div class="card-action">

      <slot name="exit"></slot>

      <MaterializecssModal
          type="fixed-bottom"
          ref="newModal"
          trigger-icon="add"
          triggerText="Carica documento"
          :parent-classes="['inline']"
          closeText="Annulla"
          :close-classes="['btn','red']"
      >

        <div class="card">
          <div class="card-content">
            <h4 class="card-title">Carica nuovo documento</h4>
            <div class="row">
              <div class="col s12">
                <label :for="'type_'+id" style="font-size:1.2rem">Tipologia documento</label>
                <select2
                    :options="doc_types"
                    v-model="doc_type"
                    :settings="doc_type_settings"
                    :id="'type_'+id">
                </select2>
              </div>

              <div class="col s12">
                <p v-if="doc_type === null">Devi selezionare una tipologia di documento prima di continuare</p>

                <div v-else-if="doc_type === 'certificate'">
                  <p>Stai caricando un certificato. Ricordati che deve essere visibile:</p>
                  <ul class="browser-default">
                    <li>Il numero di polizza</li>
                    <li>Se in sostituzione di polizza precedente, il vecchio numero di polizza</li>
                    <li>Il nome legale del gruppo</li>
                  </ul>
                </div>

                <div v-else-if="doc_type === 'policy'">
                  <p>Stai caricando le condizioni assicurative. Ricordati che deve essere visibile:</p>
                  <ul class="browser-default">
                    <li>Il numero di polizza</li>
                    <li>Le condizioni per esteso della polizza assicurativa</li>
                  </ul>
                </div>

                <div v-else-if="doc_type === 'receipt'">
                  <p>Stai caricando una ricevuta di pagamento. Ricordati che deve essere visibile:</p>
                  <ul class="browser-default">
                    <li>Il numero di polizza</li>
                    <li>La somma pagata</li>
                    <li>Una dicitura dove si attesta il pagamento della somma versata</li>
                  </ul>
                </div>
              </div>

              <div class="col s12" v-if="doc_type !== null">
                <div class="card lighten-4" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                  <div class="card-content">
                    <h3><label :for="'file_input_'+id">Trascina un immagine dentro questo box, oppure <u>clicca qui</u>.
                    </label></h3>
                    <div class="row">
                      <div class="col s12">
                        <div class="input-field">
                          <input :id="'file_input_'+id" multiple type="file" ref="file" @input="input"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </MaterializecssModal>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';

export default {
  name: "DirectoryManager",

  props: {
    insurance: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {

      myinsurance: {},
      files: [],

      uploadedFiles: [],

      updater: 0,
      loaded: false,
      newModalOpened: false,
      doc_type: null,
      id: '',
      doc_types: [
        {
          id: 'certificate',
          text: 'Certificato assicurativo',
        },
        {
          id: 'policy',
          text: 'Condizioni polizza',
        },
        {
          id: 'receipt',
          text: 'Ricevuta di pagamento',
        }
      ],
      doc_type_settings: {
        placeholder: {
          id: 'none',
          text: 'Seleziona una tipologia di certificati'
        }
      }
    }
  },

  methods: {

    formatBytes: function (bytes, decimals = 1, k = 1024) {
      if (bytes === 0) return '0 Bytes';

      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },

    loadInsurance: function () {
      let formData = new FormData();
      formData.append('insurance_id', this.insurance.id);

      Vue.set(this, 'myinsurance', {});

      window.axios.get('/index.php?option=com_api&app=asdgest&resource=insurance&insurance_id=' + this.insurance.id)
          .then(this.onNewInsurance)
          .catch(console.log);
    },

    onNewInsurance(response) {
      // console.log('Updated insurance', response);
      if (response.data.code === 200) {
        this.getFiles(response.data.data.files);
        Vue.set(this, 'myinsurance', response.data.data);
      }
      this.updater++;
    },

    getFiles: function (data = null) {
      if (data !== null) {
        // console.log('Files: ', data);
        Vue.set(this, 'files', data);
      } else {
        // console.log('Files from old insurance', data);
        Vue.set(this, 'files', this.insurance.files);
      }
    },

    getInsurance: function () {
      Vue.set(this, 'myinsurance', this.insurance);
    },

    handleFileUrl: function () {
      // Set up requests

      let formData = new FormData();

      formData.append('doc_type', this.doc_type);
      formData.append('insurance_id', this.insurance.id);

      for (let file of this.uploadedFiles) {
        formData.append('files[]', file);
      }
      formData.append('file', this.uploadedFiles[0]);

      window.axios.post('/index.php?option=com_api&app=asdgest&resource=insurance', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(response => {

            if (response.data.code !== 200) {
              alert(response.data.message);
            }

            this.cleanFileUpload();

            this.loadInsurance();
          })
          .catch(error => {
            console.log(error);
            alert('Qualcosa non va, contatta admin@ucis.org');
            this.cleanFileUpload();
          });
    },

    cleanFileUpload: function () {
      this.$refs.newModal.close();
      this.$refs.file.value = null;
      this.doc_type = null;
      Vue.set(this, 'uploadedFiles', []);
    },

    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('green')) {
        event.currentTarget.classList.add('green');
      }
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('green');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      // Clean up
      event.currentTarget.classList.remove('green');

      this.input();

      // this.handleFileUrl(); // Trigger the onChange event manually
    },

    input: function () {
      console.log('FILE CHANGED', this.$refs.file.files);
      this.uploadedFiles = this.$refs.file.files;
      this.handleFileUrl();
    },

    doc_type_name: function (name) {
      switch (name) {
        case 'certificate':
          return 'Certificato';
        case 'receipt':
          return 'Ricevuta';
        case 'policy':
          return 'Condizioni';
        default:
          return 'Non specificato';
      }

    },

    downloadFile: function(url) {
      let base = '/storage/group-'+this.insurance.group_id+'/';

      window.open(base+url, '_blank');
      //console.log('Open this link in a new tab:', );
    },

    deleteFile: function(Key) {

      let formData = new FormData;
      formData.append('group_id', this.insurance.group_id);
      formData.append('insurance_id', this.insurance.id);
      formData.append('deleteKey', Key);

      if (confirm('Sei sicuro di voler eliminare questo file? È un azione non ripristinabile')) {
        window.axios({
          url: '/index.php?option=com_api&app=asdgest&resource=file',
          method: 'delete',
          data: {
            group_id: this.insurance.group_id,
            insurance_id: this.insurance.id,
            deleteKey: Key,
            entity_type: 'insurance'
          }
        })
          .then ( response => {
            if (response.hasOwnProperty('data') && response.data.hasOwnProperty('ok') && response.data.ok === true) {
              alert('Eliminazione avvenuta');
              this.loadInsurance();
            }
            else {
              let message = response.data.message;
              alert('Eliminazione non avvenuta: '+message);
            }
          })
          .catch (console.log);
      } else {
        console.log('Cancellazione annullata');
      }
    }
  },

  created() {
    this.id = this._uid;
    this.getFiles();
    this.getInsurance();

    console.log('Insurance is ', this.insurance);
  },

  mounted() {
    this.getFiles();
    //this.loadInsurance();
    //initSelects();
  }
}
</script>

<style scoped>

</style>
